<template>
  <div class="page-wrapper">
    <div class="page-content--bge5">
      <div class="container">
        <div class="login-wrap">
          <div class="login-logo">
            <img alt="" src="/images/logo.png" class="sidebar-logo">
          </div>
          <div class="card border border-success" v-if="!confirmed">
            <div class="card-header">
              <strong class="card-title">Congratulations!</strong>
            </div>
            <div class="card-body">
              <p class="card-text au-alert" style="padding: 0;">
                <i class="zmdi zmdi-check-circle"></i>Your registration has been completed.
              </p>
              <div class="register-link">
                <p>
                  <router-link :to="{name: 'SignIn'}" tag="a">Sign In</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      confirmed: false,
    };
  },
  created() {
    const code = this.$route.params.code;
    this.$store.dispatch('finish', code)
      .then(() => {
        this.confirmed = true;
      })
      .catch(() => {
        this.$router.push({ name: 'SignIn' });
      });
  },
};
</script>
